import { Navigate, Route, Routes } from 'react-router-dom';

import { MenuInfo } from 'data';
import { Error404 } from 'pages';
import { MonitoringSettingTabsLayout } from 'layout/monitoring';

export default function MonitoringReportDataroomTabsRoutes(props) {
    const { menuId } = props;
    const tabs = MenuInfo.ROOT.find(menuId);
    return (
        <Routes>
            <Route path="/*" element={ <MonitoringSettingTabsLayout menuId={menuId}/> }>
                <Route path="/*" element={ <Navigate to={tabs.children[0].path}/> }/>
                {
                    tabs.children.map(child => {
                        return (
                            <Route key={child.id} path={child.path + (child.isRoutes ? '/*' : '')} element={ child.element }/>
                        );
                    }) 
                }
                <Route path="*" element={ <Error404/> }/>
            </Route>
        </Routes>
    );
}